import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import styles from "../hik.module.css";

const EightMSmart = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      className={styles.productDetails}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <motion.div
        className={styles.productImage}
        initial={{ x: -200 }}
        animate={{ x: 0 }}
        transition={{ type: "spring", stiffness: 100 }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/05-hikvision/cam/out/details/8Mp/01.png`}
          alt={t("eightMSmart.productImageAlt")}
        />
      </motion.div>
      <motion.div
        className={styles.productInfo}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <motion.h1
          className={styles.productTitle}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          {t("eightMSmart.title")}
        </motion.h1>
        <motion.ul className={styles.productFeatures}>
          <motion.li
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            {t("eightMSmart.feature1")}
          </motion.li>
          <motion.li
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.6, duration: 0.6 }}
          >
            {t("eightMSmart.feature2")}
          </motion.li>
          <motion.li
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.8, duration: 0.6 }}
          >
            {t("eightMSmart.feature3")}
          </motion.li>
          <motion.li
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1, duration: 0.6 }}
          >
            {t("eightMSmart.feature4")}
          </motion.li>
          <motion.li
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.2, duration: 0.6 }}
          >
            {t("eightMSmart.feature5")}
          </motion.li>
          <motion.li
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.4, duration: 0.6 }}
          >
            {t("eightMSmart.feature6")}
          </motion.li>
          <motion.li
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.6, duration: 0.6 }}
          >
            {t("eightMSmart.feature7")}
          </motion.li>
          <motion.li
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.8, duration: 0.6 }}
          >
            <div style={{width: "100%", display: "flex", gap: "15px", justifyContent: "center" }}>
              <img style={{width: "40px"}}
                src={`${process.env.PUBLIC_URL}/images/05-hikvision/cam/out/details/8Mp/icons/01.png`}
                alt=""
              />
              <img style={{width: "40px"}}
                src={`${process.env.PUBLIC_URL}/images/05-hikvision/cam/out/details/8Mp/icons/02.png`}
                alt=""
              />
              <img style={{width: "40px"}}
                src={`${process.env.PUBLIC_URL}/images/05-hikvision/cam/out/details/8Mp/icons/03.png`}
                alt=""
              />
              <img style={{width: "40px"}}
                src={`${process.env.PUBLIC_URL}/images/05-hikvision/cam/out/details/8Mp/icons/04.png`}
                alt=""
              />
            </div>
          </motion.li>
        </motion.ul>
      </motion.div>
    </motion.div>
  );
};

export default EightMSmart;
